import moment from 'moment'

const formatDate = function (date, requiredFormat) {
    if (!requiredFormat) requiredFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    if (date) {
        return moment.parseZone(String(date)).format(requiredFormat);
    }
};

export default formatDate;